module.exports = __webpack_public_path__ + "static/perfect-peace-1f86396f417535791daf8eb4213d991b.jpg";